var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBanner
    ? _c(
        "div",
        { staticClass: "unpaid-invoice-banner-wrapper" },
        [
          _c("transition", { attrs: { name: "slide-down" } }, [
            _vm.bannerVisible
              ? _c(
                  "div",
                  {
                    staticClass: "unpaid-invoice-banner",
                    class: { "banner-urgent": _vm.isUrgent },
                  },
                  [
                    _c("div", { staticClass: "banner-main" }, [
                      _c(
                        "div",
                        {
                          staticClass: "banner-content",
                          on: { click: _vm.goToBilling },
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "material-icons warning-icon" },
                            [_vm._v("warning")]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "banner-text-wrapper" }, [
                            _c("span", { staticClass: "banner-text" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.bannerMessage) +
                                  "\n                        "
                              ),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "banner-click-text" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(_vm.$t("billing.clickToPay")) +
                                  "\n                        "
                              ),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close-btn",
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.closeBanner.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("close"),
                          ]),
                        ]
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }